(function($, root) {
  "use strict";

  /**
   * vertical timeline
   */

  $('body').on('mouseover', '#vertical-timeline .goDown', function() {

    let height = $('#vertical-timeline .wrapper .content .years').innerHeight();
    let docHeight = $(document).height();
    height = height * .9;

    window.rdo.verticaltimeline.scroll.scroll_interval = setInterval(function() {
      let pos = $('#vertical-timeline .wrapper .content').scrollTop();

      if (pos < height) {
        $('#vertical-timeline .wrapper .content').scrollTop(pos + window.rdo.verticaltimeline.scroll.scroll_count);
        // console.log('scrolling ' + pos + '/' + height);
        // window.rdo.verticaltimeline.scroll.scroll_count *= 1.01;
      } else {
        window.rdo.verticaltimeline.scroll.scroll_count = 0;
      }

    }, 5);
  });

  $('body').on('mouseover', '#vertical-timeline .goUp', function() {

    window.rdo.verticaltimeline.scroll.scroll_interval = setInterval(function() {
      let pos = $('#vertical-timeline .wrapper .content').scrollTop();
      // console.log('scrolling ' + pos);

      if (pos > 0) {
        // console.log('scrolling ' + pos + '/' + height);
        $('#vertical-timeline .wrapper .content').scrollTop(pos - window.rdo.verticaltimeline.scroll.scroll_count);
        // window.rdo.verticaltimeline.scroll.scroll_count *= 1.01;
      } else {
        window.rdo.verticaltimeline.scroll.scroll_count = 0;
      }
    }, 5);

  });
  $('body').on('mouseout', '#vertical-timeline', function() {
    $.continueTimer();
  });
  $('body').on('mouseover', '#vertical-timeline', function() {
    $.pauseTimer();
  });

  // $('body').on('mouseout', '#horizontal-timeline point, .share ul li', function() {
  //   $.continueTimer();
  // });
  // $('body').on('mouseover', '#horizontal-timeline point, .share ul li', function() {
  //   $.pauseTimer(false);
  // });

  $('body').on('mouseout', '#horizontal-timeline point', function() {
    $.continueTimer();
  });
  $('body').on('mouseover', '#horizontal-timeline point', function() {
    $.pauseTimer(false);
  });

  $.scrollVerticalTimeline = function(year) {
    year = year || window.rdo.data.selected.year.year;
    let targetYear = $('#vs-year-' + year);

    $('#vertical-timeline .years .year.active').removeClass('active');
    // let pos = targetYear.position();
    // console.log('going to year:' + pos.top);
    // pos = pos.top - window.rdo.verticaltimeline.scroll.initialtop;
    let pos = window.rdo.verticaltimeline.scroll.initialsize * parseInt(targetYear.attr('data-index'));
    // console.log('going to year s:' + pos);
    // console.log(targetYear.offset());
    $('#vertical-timeline .wrapper .content').scrollTop(pos);
    targetYear.addClass('active');

  }

  $.scrollVerticalTimelinePos = function(year) {
    year = year || window.rdo.data.selected.year.year;

    let targetYear = $('#vs-year-' + year);
    let targetSubject = null;

    // console.log(window.rdo.data.selected);

    // if (window.rdo.verticaltimeline.wait) {
    //   console.log('WIAITING TO SCROLL :' + window.rdo.verticaltimeline.wait);
    // }
    setTimeout(function() {

      if (window.rdo.data.selected.year.subjects.length > 1) {
        // console.log('selected subject index :' + window.rdo.data.selected.subject.index);
        targetSubject = $('#vs-year-' + year + ' .subject-lines [data-target=' + window.rdo.data.selected.subject.ID + ']');
      }

      $.resetScrolls();

      let docHeight = $(document).height();
      // year = year || window.rdo.data.selected.year.year;
      // let targetYear = $('#vertical-timeline .years .year.active');

      let height = $('#vertical-timeline .wrapper .content .years').innerHeight();
      height = height * .85;

      let pos = parseInt(targetYear.attr('data-offset'));
      // console.log('data-offset is :' + pos);
      // console.log(targetSubject);
      if (targetSubject) {
        pos = parseInt(targetSubject.attr('data-offset'));
      }
      pos = pos - (docHeight * .3);
      // pos = pos.top - (docHeight * .3);
      if (pos < 0) {
        pos = 0;
      }
      if (pos > height) {
        pos = height;
      }

      $('#vertical-timeline .wrapper .content').scrollTo(500, pos);

      $('#vertical-timeline .years .active').removeClass('active');
      targetYear.addClass('active');
      if (targetSubject) {
        targetSubject.addClass('active');
      }

    }, window.rdo.verticaltimeline.wait);

  }

  /**
   * vertical timeline
   */

  /**
   * index
   */

  $('body').on('mouseover', 'index .goDown', function() {
    let height = $('index .years').outerHeight();
    // height = height * .9;

    window.rdo.verticaltimeline.scroll.scroll_interval = setInterval(function() {
      let pos = parseInt($('index .scrollrow').scrollTop());
      // console.log('pos is ' + pos);
      // console.log('scroll count is: ' + window.rdo.verticaltimeline.scroll.scroll_count);

      if (pos < height) {
        $('index .scrollrow').scrollTop(pos + window.rdo.verticaltimeline.scroll.scroll_count);
        // console.log('scrolling ' + pos + '/' + height);
        // window.rdo.verticaltimeline.scroll.scroll_count *= 1.01;
      } else {
        window.rdo.verticaltimeline.scroll.scroll_count = 0;
      }
    }, 5);
  });

  $('body').on('mouseover', 'index .goUp', function() {

    window.rdo.verticaltimeline.scroll.scroll_interval = setInterval(function() {
      let pos = parseInt($('index .scrollrow').scrollTop());
      if (pos > 0) {
        $('index .scrollrow').scrollTop(pos - window.rdo.verticaltimeline.scroll.scroll_count);
      } else {
        window.rdo.verticaltimeline.scroll.scroll_count = 0;
      }
    }, 5);

  });

  /**
   * index
   */


   /**
    * modal
    */

   $('body').on('mouseover', 'modal .goDown', function() {
     let height = $('modal .content').outerHeight();
     // height = height * .9;

     window.rdo.verticaltimeline.scroll.scroll_interval = setInterval(function() {
       let pos = parseInt($('modal .scrollrow').scrollTop());
       // console.log('pos is ' + pos);
       // console.log('scroll count is: ' + window.rdo.verticaltimeline.scroll.scroll_count);

       if (pos < height) {
         $('modal .scrollrow').scrollTop(pos + window.rdo.verticaltimeline.scroll.scroll_count);
         // console.log('scrolling ' + pos + '/' + height);
         // window.rdo.verticaltimeline.scroll.scroll_count *= 1.01;
       } else {
         window.rdo.verticaltimeline.scroll.scroll_count = 0;
       }
     }, 5);
   });

   $('body').on('mouseover', 'modal .goUp', function() {

     window.rdo.verticaltimeline.scroll.scroll_interval = setInterval(function() {
       let pos = parseInt($('modal .scrollrow').scrollTop());
       if (pos > 0) {
         $('modal .scrollrow').scrollTop(pos - window.rdo.verticaltimeline.scroll.scroll_count);
       } else {
         window.rdo.verticaltimeline.scroll.scroll_count = 0;
       }
     }, 5);

   });

   /**
    * modal
    */

  /**
   * detail
   */

  $('body').on('mouseover', '.detail.goDown', function() {
    let height = $('.detail-content').innerHeight();
    height = height * .9;

    window.rdo.verticaltimeline.scroll.scroll_interval = setInterval(function() {
      let pos = parseInt($('#content-detail .wrapper').scrollTop());
      console.log('pos is ' + pos);
      console.log('scroll count is: ' + window.rdo.verticaltimeline.scroll.scroll_count);

      if (pos < height) {
        $('#content-detail .wrapper').scrollTop(pos + window.rdo.verticaltimeline.scroll.scroll_count);
        // console.log('scrolling ' + pos + '/' + height);
        // window.rdo.verticaltimeline.scroll.scroll_count *= 1.01;
      } else {
        window.rdo.verticaltimeline.scroll.scroll_count = 0;
      }
    }, 5);
  });

  $('body').on('mouseover', '.detail.goUp', function() {

    window.rdo.verticaltimeline.scroll.scroll_interval = setInterval(function() {
      let pos = parseInt($('#content-detail .wrapper').scrollTop());
      if (pos > 0) {
        $('#content-detail .wrapper').scrollTop(pos - window.rdo.verticaltimeline.scroll.scroll_count);
      } else {
        window.rdo.verticaltimeline.scroll.scroll_count = 0;
      }
    }, 5);

  });

  /**
   * detail
   */

  $('body').on('mouseout', '.mover', function() {
    $.resetScrolls();
  });

  $('body').on('click touchstart', '.mover', function() {
    window.rdo.verticaltimeline.scroll.scroll_count *= 1.5;
  });

  $.resetScrolls = function() {
    // console.log('RESETTING SCROLLS');
    window.rdo.verticaltimeline.scroll.scroll_count = 1;
    clearInterval(window.rdo.verticaltimeline.scroll.scroll_interval);
    window.rdo.verticaltimeline.scroll.scroll_interval = null;

  }

  $.fn.extend({

    getInitialScrollPositions: function(selector, offsetItem) {
      // var deferred = $.Deferred();
      // console.log('getting initial poisitions');
      let docHeight = $(document).height();

      // console.log('docHeight is ' + docHeight);
      let offsetItemTop = $(offsetItem).offset();
      let length = $(selector).length;
      let ix = 0;

      $(selector).each(function() {

        let offset = $(this).offset();
        // offset = offset.top - (docHeight * .3) - offsetItemTop.top;
        offset = parseInt(offset.top) - parseInt(offsetItemTop.top);
        $(this).attr('data-offset', offset);
        // console.log(ix + ' DATA offset is : ' + offset);
        ix++;
        if (ix == length) {
          console.log(' DATA offsets  DONE : ' + offset);
        }

      });

      // return deferred;
      // }, 100);

    },

    scrollTo: function(speed, top) {
      speed = speed || 'slow';

      let item = $(this);

      if (item.length) {
        // console.log(' scrollll ' + top);
        item.animate({
          scrollTop: top
        }, speed);
        window.rdo.verticaltimeline.wait = 0;
      }

      // } else {
      //   console.log('not set! I cant scroll');
      //   $('#vertical-timeline').getInitialScrollPositions('.sitem', '#vertical-timeline .wrapper').done(
      //     function() {
      //       window.rdo.verticaltimeline.scoll_target.scrollTo(speed, top);
      //     }
      //   );
      //
      // }

    },
  });

})(jQuery, this);
